<template>
  <material-card
    :title="`${$t('Configuration')}`"
    color="dover-blue">
    <v-form
      ref="form"
      v-model="isValidationOk"
      lazy-validation >
      <v-card>
        <v-container
          fluid
          grid-list-md>
          <v-flex
            xs12
            md12
            lg12>
            <v-layout
              row
              wrap>
              <v-flex
                xs10
                md10
                lg10>
                <v-layout
                  row
                  wrap>
                  <v-flex
                    xs2
                    md2
                    lg2>
                    <v-switch
                      v-model="relayTank"
                      :label="`${ $t('Print Tanks Relays') }`"
                      class="dover-input text-xs-center" />
                  </v-flex>
                  <v-flex
                    xs2
                    md2
                    lg2>
                    <v-switch
                      v-model="relaySensor"
                      :label="`${ $t('Print Sensors Relays') }`"
                      class="dover-input text-xs-center" />
                  </v-flex>
                  <v-flex
                    v-if="Maglink.isPlus"
                    xs2
                    md2
                    lg2>
                    <v-switch
                      v-model="relayLld"
                      :label="`${ $t('Print LLDs Relays') }`"
                      class="dover-input text-xs-center" />
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex
                xs2
                md2
                lg2
                text-xs-right>
                <v-btn
                  small
                  class="mx-0 font-weight-light"
                  color="dover-blue"
                  @click="onPrintForm">
                  {{ $t('Print') }}
                </v-btn>
              </v-flex>
            </v-layout>
            <v-form
              id="print-layout">
              <v-layout
                row
                wrap>
                <v-flex
                  xs12
                  md12
                  lg12>
                  <span
                    class="dover-blue-color">
                    {{ $t('Site info') }}
                  </span>
                  <hr>
                </v-flex>
                <v-flex
                  xs12
                  md12
                  lg12>
                  <table>
                    <tr>
                      <td style="font-weight: Bold; padding-right: 10px">{{ $t('Console serial') }} </td>
                      <td>{{ siteInfo.consoleSerial }}</td>
                    </tr>
                    <tr>
                      <td style="font-weight: Bold; padding-right: 10px">{{ $t('Name') }} </td>
                      <td>{{ siteInfo.name }}</td>
                    </tr>
                    <tr>
                      <td style="font-weight: Bold; padding-right: 10px">{{ $t('ESN') }} </td>
                      <td>{{ featureSettings.serialNumber }}</td>
                    </tr>
                    <tr>
                      <td style="font-weight: Bold; padding-right: 10px">{{ $t('Address') + ' 1' }} </td>
                      <td>{{ siteInfo.header1 }}</td>
                    </tr>
                    <tr>
                      <td style="font-weight: Bold; padding-right: 10px">{{ $t('Address') + ' 2' }} </td>
                      <td>{{ siteInfo.header2 }}</td>
                    </tr>
                    <tr>
                      <td style="font-weight: Bold; padding-right: 10px">{{ $t('Address') + ' 3' }} </td>
                      <td>{{ siteInfo.header3 }}</td>
                    </tr>
                    <tr>
                      <td style="font-weight: Bold; padding-right: 10px">{{ $t('Total external relays') }} </td>
                      <td>{{ siteInfo.externalRelays }}</td>
                    </tr>
                    <tr>
                      <td style="font-weight: Bold; padding-right: 10px">{{ $t('Total OM4 relays') }} </td>
                      <td>{{ siteInfo.externalOM4Relays }}</td>
                    </tr>
                  </table>
                </v-flex>
              </v-layout>
              <v-layout
                row
                wrap>
                <v-flex
                  xs12
                  md12
                  lg12>
                  <span
                    class="dover-blue-color">
                    {{ $t('Settings') }}
                  </span>
                  <hr>
                </v-flex>
                <v-flex
                  xs4
                  md4
                  lg4>
                  <v-layout
                    row
                    wrap>
                    <v-flex
                      xs12
                      md12
                      lg12>
                      <span class="dover-light-blue-color">
                        {{ $t('System') }}
                      </span>
                      <hr>
                    </v-flex>
                    <v-flex
                      xs12
                      md12
                      lg12>
                      <table>
                        <tr>
                          <td style="font-weight: Bold; padding-right: 10px">{{ $t('Console language') }} </td>
                          <td>{{ language }}</td>
                        </tr>
                        <tr>
                          <td style="font-weight: Bold; padding-right: 10px">{{ $t('Date formats') }} </td>
                          <td>{{ systemSettings.dateFormat }}</td>
                        </tr>
                        <tr>
                          <td style="font-weight: Bold; padding-right: 10px">{{ $t('Level') }} </td>
                          <td>{{ systemSettings.levelUnitLabel }}</td>
                        </tr>
                        <tr>
                          <td style="font-weight: Bold; padding-right: 10px">{{ $t('Volume') }} </td>
                          <td>{{ systemSettings.volumeUnitLabel }}</td>
                        </tr>
                        <tr>
                          <td style="font-weight: Bold; padding-right: 10px">{{ $t('TC volume') }} </td>
                          <td>{{ systemSettings.temperature + ' ' + systemSettings.temperatureUnitLabel }}</td>
                        </tr>
                        <tr>
                          <td style="font-weight: Bold; padding-right: 10px">{{ $t('Temperature') }} </td>
                          <td>{{ systemSettings.temperatureUnitLabel }}</td>
                        </tr>
                        <tr>
                          <td style="font-weight: Bold; padding-right: 10px">{{ $t('Leak') }} </td>
                          <td>{{ systemSettings.leakUnitLabel }}</td>
                        </tr>
                        <tr>
                          <td style="font-weight: Bold; padding-right: 10px">{{ $t('Weight') }} </td>
                          <td>{{ systemSettings.weightUnitLabel }}</td>
                        </tr>
                        <tr>
                          <td style="font-weight: Bold; padding-right: 10px">{{ $t('Alarm settings') }} </td>
                          <td>{{ systemSettings.alarmHysteresisLevel }}</td>
                        </tr>
                        <tr>
                          <td style="font-weight: Bold; padding-right: 10px">{{ $t('Alarm Buzzer') }} </td>
                          <td>{{ buzzerLabel }}</td>
                        </tr>
                      </table>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex
                  xs4
                  md4
                  lg4>
                  <v-layout
                    row
                    wrap>
                    <v-flex
                      xs12
                      md12
                      lg12>
                      <span class="dover-light-blue-color">
                        {{ $t('Fairbanks') }}
                      </span>
                      <hr>
                    </v-flex>
                    <v-flex
                      xs12
                      md12
                      lg12>
                      <table>
                        <tr>
                          <td style="font-weight: Bold; padding-right: 10px">{{ $t('Server') }} </td>
                          <td>{{ fairbanks.server }}</td>
                        </tr>
                        <tr>
                          <td style="font-weight: Bold; padding-right: 10px">{{ $t('Port') }} </td>
                          <td>{{ fairbanks.port }}</td>
                        </tr>
                        <tr>
                          <td style="font-weight: Bold; padding-right: 10px">{{ $t('SFTP') }} </td>
                          <td>{{ getSftpStatus(fairbanks.enableSSL) }}</td>
                        </tr>
                        <tr>
                          <td style="font-weight: Bold; padding-right: 10px">{{ $t('Transfer mode') }} </td>
                          <td>{{ getTransferMode(fairbanks.transferMode) }}</td>
                        </tr>
                        <tr>
                          <td style="font-weight: Bold; padding-right: 10px">{{ $t('Folder') }} </td>
                          <td>{{ fairbanks.folder }}</td>
                        </tr>
                        <tr>
                          <td style="font-weight: Bold; padding-right: 10px">{{ $t('User') }} </td>
                          <td>{{ fairbanks.user }}</td>
                        </tr>
                        <tr>
                          <td style="font-weight: Bold; padding-right: 10px">{{ $t('Id') }} </td>
                          <td>{{ fairbanks.id }}</td>
                        </tr>
                        <tr>
                          <td style="font-weight: Bold; padding-right: 10px">{{ $t('Upload interval (min)') }} </td>
                          <td>{{ fairbanks.uploadInterval }}</td>
                        </tr>
                      </table>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex
                  xs4
                  md4
                  lg4>
                  <v-layout
                    row
                    wrap>
                    <v-flex
                      xs12
                      md12
                      lg12>
                      <span class="dover-light-blue-color">
                        {{ $t('Network configuration') }}
                      </span>
                      <hr>
                    </v-flex>
                    <v-flex
                      xs12
                      md12
                      lg12>
                      <table>
                        <tr>
                          <td style="font-weight: Bold; padding-right: 10px">{{ $t('Type') }} </td>
                          <td>{{ getNetworkMode(network.dhcp) }}</td>
                        </tr>
                        <tr>
                          <td style="font-weight: Bold; padding-right: 10px">{{ $t('TCP-IP') }} </td>
                          <td>{{ network.ip }}</td>
                        </tr>
                        <tr>
                          <td style="font-weight: Bold; padding-right: 10px">{{ $t('Port') }} </td>
                          <td>{{ network.port }}</td>
                        </tr>
                        <tr>
                          <td style="font-weight: Bold; padding-right: 10px">{{ $t('Mask') }} </td>
                          <td>{{ network.mask }}</td>
                        </tr>
                        <tr>
                          <td style="font-weight: Bold; padding-right: 10px">{{ $t('Gateway') }} </td>
                          <td>{{ network.gateway }}</td>
                        </tr>
                        <tr>
                          <td style="font-weight: Bold; padding-right: 10px">{{ $t('DNS {0}', ['1']) }} </td>
                          <td>{{ network.dns1 }}</td>
                        </tr>
                        <tr>
                          <td style="font-weight: Bold; padding-right: 10px">{{ $t('DNS {0}', ['2']) }} </td>
                          <td>{{ network.dns2 }}</td>
                        </tr>
                      </table>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
              <v-layout
                row
                wrap>
                <v-flex
                  xs12
                  md12
                  lg12>
                  <span
                    class="dover-blue-color">
                    {{ $t('Dipswitch settings') }}
                  </span>
                  <hr>
                </v-flex>
                <v-flex
                  xs12
                  md12
                  lg12>
                  <v-data-table
                    :headers="hDipSwitch"
                    :items="dipswitches"
                    :no-data-text="`${ Maglink.NoDataMessage(false) }`"
                    :no-results-text="`${ Maglink.NoDataMessage(true) }`"
                    hide-actions>
                    <template
                      slot="headerCell"
                      slot-scope="{ header }">
                      <span
                        class="dover-light-blue-color"
                        v-text="header.text" />
                    </template>
                    <template
                      v-if="index === 7 || index < (Maglink.isPlus ? 1 : 2)"
                      slot="items"
                      slot-scope="{ index, item }"
                      class="dover-light-blue-color">
                      <td class="text-xs-center">{{ index + 1 }}</td>
                      <td class="text-xs-center"> {{ getSwitchStatus(item.enabled) }} </td>
                      <td >{{ $t(item.name) }}</td>
                      <td >{{ getDescription(index) }}</td>
                    </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
              <v-layout
                row
                wrap>
                <v-flex
                  xs12
                  md12
                  lg12>
                  <span
                    class="dover-blue-color">
                    {{ $t('Protocols') }}
                  </span>
                  <hr>
                </v-flex>
                <v-flex
                  xs12
                  md12
                  lg12>
                  <v-data-table
                    :headers="hProtocol"
                    :items="mainSettings.posProtocols"
                    :no-data-text="`${ Maglink.NoDataMessage(false) }`"
                    :no-results-text="`${ Maglink.NoDataMessage(true) }`"
                    hide-actions>
                    <template
                      slot="headerCell"
                      slot-scope="{ header }">
                      <span
                        class="dover-light-blue-color"
                        v-text="header.text" />
                    </template>
                    <template
                      slot="items"
                      slot-scope="{ item }"
                      class="dover-light-blue-color">
                      <td class="text-xs-center"> {{ item.pos }} </td>
                      <td class="text-xs-center"> {{ getLink(item.type) }} </td>
                      <td class="text-xs-center"> {{ item.acr ? $t('Yes') : $t('No') }} </td>
                      <td> {{ getProtocol(item.protocol) }} </td>
                      <td class="text-xs-center"> {{ item.port }} </td>
                      <td class="text-xs-center"> {{ getBaudRate(item) }} </td>
                      <td class="text-xs-center"> {{ getParity(item) }} </td>
                      <td class="text-xs-center"> {{ getDataBit(item) }} </td>
                      <td class="text-xs-center"> {{ getStopBit(item) }} </td>
                    </template>
                  </v-data-table>
                </v-flex>
                <v-flex
                  xs12
                  md12
                  lg12>
                  <table>
                    <tr>
                      <td style="font-weight: Bold; padding-right: 10px">{{ $t('Gilbarco invalid field character') }} </td>
                      <td>{{ getGilbarcoInvalidField(mainSettings.gilbarcoInvalidDataFill) }}</td>
                    </tr>
                    <tr>
                      <td style="font-weight: Bold; padding-right: 10px">{{ $t('Printer connection') }} </td>
                      <td>{{ getPrinter(mainSettings.printer) }}</td>
                    </tr>
                  </table>
                </v-flex>
              </v-layout>
              <v-layout
                row
                wrap>
                <v-flex
                  xs12
                  md12
                  lg12
                  mt-4>
                  <span
                    class="dover-blue-color">
                    {{ $t('Tanks') }}
                  </span>
                  <hr>
                </v-flex>
                <v-flex
                  xs12
                  md12
                  lg12>
                  <v-data-iterator
                    :items="tanks"
                    :row-per-page-items="-1"
                    content-tag="v-layout"
                    hide-actions
                    row
                    wrap>
                    <template v-slot:item="props">
                      <v-flex
                        xs12
                        md12
                        lg12
                        mt-4>
                        <span
                          class="dover-blue-color">
                          {{ props.item.tankNumber + ' - ' + props.item.tankDescription }}
                        </span>
                        <hr>
                      </v-flex>
                      <v-flex
                        xs12
                        md12
                        lg12>
                        <v-data-table
                          :headers="hTank"
                          :items="getItemAsList(props.item)"
                          :no-data-text="`${ Maglink.NoDataMessage(false) }`"
                          :no-results-text="`${ Maglink.NoDataMessage(true) }`"
                          hide-actions>
                          <template
                            slot="headerCell"
                            slot-scope="{ header }">
                            <span
                              class="dover-light-blue-color"
                              v-text="header.text" />
                          </template>
                          <template
                            slot="items"
                            slot-scope="{ item }"
                            class="dover-light-blue-color">
                            <td class="text-xs-center"> {{ item.serial }}</td>
                            <td> {{ getProbeType(item.probeType) }}</td>
                            <td> {{ getProductName(item.tankNumber) }}</td>
                            <td> {{ getTankGroupName(item.tankNumber) }}</td>
                            <td class="text-xs-right"> {{ item.maxLevel }}</td>
                            <td class="text-xs-right"> {{ item.maxVolume }}</td>
                            <td class="text-xs-right"> {{ item.offsetProductLevel }}</td>
                            <td class="text-xs-right"> {{ item.offsetWaterLevel }}</td>
                            <td class="text-xs-right"> {{ item.waterMinFloatLevel }}</td>
                          </template>
                        </v-data-table>
                      </v-flex>

                      <v-flex
                        xs12
                        md12
                        lg12>
                        <span
                          class="dover-light-blue-color">
                          {{ $t('Thresholds') }}
                        </span>
                        <hr>
                      </v-flex>
                      <v-flex
                        xs12
                        md12
                        lg12>
                        <v-data-table
                          :headers="hThreshold"
                          :items="getItemAsList(props.item)"
                          :no-data-text="`${ Maglink.NoDataMessage(false) }`"
                          :no-results-text="`${ Maglink.NoDataMessage(true) }`"
                          hide-actions>
                          <template
                            slot="headerCell"
                            slot-scope="{ header }">
                            <span
                              class="dover-light-blue-color"
                              v-text="header.text" />
                          </template>
                          <template
                            slot="items"
                            slot-scope="{ item }"
                            class="dover-light-blue-color">
                            <td class="text-xs-center"> {{ item.workingCapacity + '%' }}</td>
                            <td class="text-xs-right"> {{ item.alarmHHLevel }}</td>
                            <td class="text-xs-right"> {{ item.alarmHLevel }}</td>
                            <td class="text-xs-right"> {{ item.alarmLLevel }}</td>
                            <td class="text-xs-right"> {{ item.alarmLLLevel }}</td>
                            <td class="text-xs-right"> {{ getWaterLevel(item.probeWaterFloat, item.alarmWaterLevel) }}</td>
                            <td class="text-xs-right"> {{ getAEFLevel(item.isAEFfloat, item.aefT1outerLevel) }}</td>
                            <td class="text-xs-right"> {{ getAEFLevel(item.isAEFfloat, item.aefT1innerLevel) }}</td>
                            <td class="text-xs-right"> {{ getAEFLevel(item.isAEFfloat, item.aefT2innerLevel) }}</td>
                            <td class="text-xs-right"> {{ getAEFLevel(item.isAEFfloat, item.aefT2outerLevel) }}</td>
                            <td class="text-xs-right"> {{ item.theftThreshold }}</td>
                            <td class="text-xs-right"> {{ getLeakValue(item.customTankLeakRate, item.probeType) }}</td>
                          </template>
                        </v-data-table>
                      </v-flex>

                      <v-flex
                        v-if="relayTank"
                        xs12
                        md12
                        lg12>
                        <span
                          class="dover-light-blue-color">
                          {{ $t('Relays') }}
                        </span>
                        <hr>
                      </v-flex>
                      <v-layout
                        v-if="relayTank"
                        row
                        wrap>
                        <v-flex
                          xs6
                          md4
                          lg4>
                          <span
                            class="dover-light-blue-color">
                            {{ $t('Internal relays') }}
                          </span>
                          <hr>
                          <v-data-table
                            :headers="hRelay"
                            :items="getInternalRelays(props.item.relays)"
                            :no-data-text="`${ Maglink.NoDataMessage(false) }`"
                            :no-results-text="`${ Maglink.NoDataMessage(true) }`"
                            hide-actions>
                            <template
                              slot="headerCell"
                              slot-scope="{ header }">
                              <span
                                class="dover-light-blue-color"
                                v-text="header.text" />
                            </template>
                            <template
                              slot="items"
                              slot-scope="{ item }"
                              class="dover-light-blue-color">
                              <td class="text-xs-center"> {{ item.relayNumber }}</td>
                              <td> {{ unpackTankTriggers(item.triggerStatus) }}</td>
                            </template>
                          </v-data-table>
                        </v-flex>
                        <v-flex
                          xs6
                          md4
                          lg4>
                          <span
                            class="dover-light-blue-color">
                            {{ $t('External relays') }}
                          </span>
                          <hr>
                          <v-data-table
                            :headers="hRelay"
                            :items="getExternalRelays(props.item.relays)"
                            :no-data-text="`${ Maglink.NoDataMessage(false) }`"
                            :no-results-text="`${ Maglink.NoDataMessage(true) }`"
                            hide-actions>
                            <template
                              slot="headerCell"
                              slot-scope="{ header }">
                              <span
                                class="dover-light-blue-color"
                                v-text="header.text" />
                            </template>
                            <template
                              slot="items"
                              slot-scope="{ item }"
                              class="dover-light-blue-color">
                              <td class="text-xs-center"> {{ item.relayNumber }}</td>
                              <td> {{ unpackTankTriggers(item.triggerStatus) }}</td>
                            </template>
                          </v-data-table>
                        </v-flex>
                        <v-flex
                          v-if="Maglink.isPlus"
                          xs6
                          md4
                          lg4>
                          <span
                            class="dover-light-blue-color">
                            {{ $t('OM4 relays') }}
                          </span>
                          <hr>
                          <v-data-table
                            :headers="hRelay"
                            :items="getExternalOM4Relays(props.item.relays)"
                            :no-data-text="`${ Maglink.NoDataMessage(false) }`"
                            :no-results-text="`${ Maglink.NoDataMessage(true) }`"
                            hide-actions>
                            <template
                              slot="headerCell"
                              slot-scope="{ header }">
                              <span
                                class="dover-light-blue-color"
                                v-text="header.text" />
                            </template>
                            <template
                              slot="items"
                              slot-scope="{ item }"
                              class="dover-light-blue-color">
                              <td class="text-xs-center"> {{ item.relayNumber }}</td>
                              <td> {{ unpackTankTriggers(item.triggerStatus) }}</td>
                            </template>
                          </v-data-table>
                        </v-flex>
                      </v-layout>
                    </template>
                  </v-data-iterator>
                </v-flex>
              </v-layout>
              <v-layout
                row
                wrap>
                <v-flex
                  xs12
                  md12
                  lg12
                  mt-4>
                  <span
                    class="dover-blue-color">
                    {{ $t('Sensors') }}
                  </span>
                  <hr>
                </v-flex>
                <v-flex
                  xs12
                  md12
                  lg12>
                  <v-data-iterator
                    :items="sensors"
                    :row-per-page-items="-1"
                    content-tag="v-layout"
                    hide-actions
                    row
                    wrap>
                    <template v-slot:item="props">
                      <v-flex
                        xs12
                        md12
                        lg12
                        mt-4>
                        <span
                          class="dover-blue-color">
                          {{ props.item.sensorNumber + ' - ' + props.item.sensorName }}
                        </span>
                        <hr>
                      </v-flex>
                      <v-flex
                        xs12
                        md12
                        lg12>
                        <v-data-table
                          :headers="hSensor"
                          :items="getItemAsList(props.item)"
                          :no-data-text="`${ Maglink.NoDataMessage(false) }`"
                          :no-results-text="`${ Maglink.NoDataMessage(true) }`"
                          hide-actions>
                          <template
                            slot="headerCell"
                            slot-scope="{ header }">
                            <span
                              class="dover-light-blue-color"
                              v-text="header.text" />
                          </template>
                          <template
                            slot="items"
                            slot-scope="{ item }"
                            class="dover-light-blue-color">
                            <td class="text-xs-center"> {{ item.serial }}</td>
                            <td> {{ getSensorType(item.sensorType) }}</td>
                            <td class="text-xs-center"> {{ getBoolean(item.compliance) }}</td>
                            <td> {{ getSensorLocation(item) }} </td>
                          </template>
                        </v-data-table>
                      </v-flex>

                      <v-flex
                        v-if="relaySensor"
                        xs12
                        md12
                        lg12>
                        <span
                          class="dover-light-blue-color">
                          {{ $t('Relays') }}
                        </span>
                        <hr>
                      </v-flex>
                      <v-layout
                        v-if="relaySensor"
                        row
                        wrap>
                        <v-flex
                          xs6
                          md4
                          lg4>
                          <span
                            class="dover-light-blue-color">
                            {{ $t('Internal relays') }}
                          </span>
                          <hr>
                          <v-data-table
                            :headers="hRelay"
                            :items="getInternalRelays(props.item.relays)"
                            :no-data-text="`${ Maglink.NoDataMessage(false) }`"
                            :no-results-text="`${ Maglink.NoDataMessage(true) }`"
                            hide-actions>
                            <template
                              slot="headerCell"
                              slot-scope="{ header }">
                              <span
                                class="dover-light-blue-color"
                                v-text="header.text" />
                            </template>
                            <template
                              slot="items"
                              slot-scope="{ item }"
                              class="dover-light-blue-color">
                              <td class="text-xs-center"> {{ item.relayNumber }}</td>
                              <td> {{ unpackSensorTriggers(item.triggerStatus) }}</td>
                            </template>
                          </v-data-table>
                        </v-flex>
                        <v-flex
                          xs6
                          md4
                          lg4>
                          <span
                            class="dover-light-blue-color">
                            {{ $t('External relays') }}
                          </span>
                          <hr>
                          <v-data-table
                            :headers="hRelay"
                            :items="getExternalRelays(props.item.relays)"
                            :no-data-text="`${ Maglink.NoDataMessage(false) }`"
                            :no-results-text="`${ Maglink.NoDataMessage(true) }`"
                            hide-actions>
                            <template
                              slot="headerCell"
                              slot-scope="{ header }">
                              <span
                                class="dover-light-blue-color"
                                v-text="header.text" />
                            </template>
                            <template
                              slot="items"
                              slot-scope="{ item }"
                              class="dover-light-blue-color">
                              <td class="text-xs-center"> {{ item.relayNumber }}</td>
                              <td> {{ unpackSensorTriggers(item.triggerStatus) }}</td>
                            </template>
                          </v-data-table>
                        </v-flex>
                        <v-flex
                          v-if="Maglink.isPlus"
                          xs6
                          md4
                          lg4>
                          <span
                            class="dover-light-blue-color">
                            {{ $t('OM4 relays') }}
                          </span>
                          <hr>
                          <v-data-table
                            :headers="hRelay"
                            :items="getExternalOM4Relays(props.item.relays)"
                            :no-data-text="`${ Maglink.NoDataMessage(false) }`"
                            :no-results-text="`${ Maglink.NoDataMessage(true) }`"
                            hide-actions>
                            <template
                              slot="headerCell"
                              slot-scope="{ header }">
                              <span
                                class="dover-light-blue-color"
                                v-text="header.text" />
                            </template>
                            <template
                              slot="items"
                              slot-scope="{ item }"
                              class="dover-light-blue-color">
                              <td class="text-xs-center"> {{ item.relayNumber }}</td>
                              <td> {{ unpackSensorTriggers(item.triggerStatus) }}</td>
                            </template>
                          </v-data-table>
                        </v-flex>
                      </v-layout>
                    </template>
                  </v-data-iterator>
                </v-flex>
              </v-layout>
              <v-layout
                v-if="Maglink.isPlus"
                row
                wrap>
                <v-flex
                  xs12
                  md12
                  lg12>
                  <span
                    class="dover-blue-color">
                    {{ $t('Line Leak Detector') }}
                  </span>
                  <hr>
                </v-flex>
                <v-flex
                  xs12
                  md12
                  lg12>
                  <v-data-iterator
                    :items="llds"
                    :row-per-page-items="-1"
                    content-tag="v-layout"
                    hide-actions
                    row
                    wrap>
                    <template v-slot:item="props">
                      <v-flex
                        xs12
                        md12
                        lg12
                        mt-4>
                        <span
                          class="dover-blue-color">
                          {{ props.item.lldNumber + ' - ' + props.item.lldDescription }}
                        </span>
                        <hr>
                      </v-flex>
                      <v-flex
                        xs12
                        md12
                        lg12>
                        <v-data-table
                          :headers="hLld"
                          :items="getItemAsList(props.item)"
                          :no-data-text="`${ Maglink.NoDataMessage(false) }`"
                          :no-results-text="`${ Maglink.NoDataMessage(true) }`"
                          hide-actions>
                          <template
                            slot="headerCell"
                            slot-scope="{ header }">
                            <span
                              class="dover-light-blue-color"
                              v-text="header.text" />
                          </template>
                          <template
                            slot="items"
                            slot-scope="{ item }"
                            class="dover-light-blue-color">
                            <td class="text-xs-center"> {{ item.tankNumber }}</td>
                            <td class="text-xs-center"> {{ getLldInfo(item.ioSensorAddress) }}</td>
                            <td class="text-xs-center"> {{ getLldInfo(item.ioSensorPosition) }} </td>
                            <td class="text-xs-right"> {{ item.sensorSpan }}</td>
                            <td class="text-xs-center"> {{ getLldInfo(item.limStpAddress) }} </td>
                            <td class="text-xs-center"> {{ getLldInfo(item.limStpPosition) }} </td>
                          </template>
                        </v-data-table>
                      </v-flex>

                      <v-flex
                        xs12
                        md12
                        lg12>
                        <span
                          class="dover-light-blue-color">
                          {{ $t('Pipeline') }}
                        </span>
                        <hr>
                      </v-flex>
                      <v-flex
                        xs12
                        md12
                        lg12>
                        <v-data-table
                          :headers="hPipeline"
                          :items="getItemAsList(props.item)"
                          :no-data-text="`${ Maglink.NoDataMessage(false) }`"
                          :no-results-text="`${ Maglink.NoDataMessage(true) }`"
                          hide-actions>
                          <template
                            slot="headerCell"
                            slot-scope="{ header }">
                            <span
                              class="dover-light-blue-color"
                              v-text="header.text" />
                          </template>
                          <template
                            slot="items"
                            slot-scope="{ item }"
                            class="dover-light-blue-color">
                            <td class="text-xs-right"> {{ item.lineBeta }}</td>
                            <td class="text-xs-right"> {{ item.lineCalibratedBeta }} </td>
                            <td class="text-xs-right"> {{ getLength(item.lineLength) }} </td>
                            <td class="text-xs-right"> {{ getVolumeinGallons(item.lineSegmentVolume) }} </td>
                            <td class="text-xs-right"> {{ getTestPressure(item.minimumTestPressure) }} </td>
                            <td class="text-xs-right"> {{ getDispensingPressure(item.minimumDispensingPressure) }} </td>
                          </template>
                        </v-data-table>
                      </v-flex>

                      <v-flex
                        v-if="relayLld"
                        xs12
                        md12
                        lg12>
                        <span
                          class="dover-light-blue-color">
                          {{ $t('Relays') }}
                        </span>
                        <hr>
                      </v-flex>
                      <v-layout
                        v-if="relayLld"
                        row
                        wrap>
                        <v-flex
                          xs6
                          md4
                          lg4>
                          <span
                            class="dover-light-blue-color">
                            {{ $t('Internal relays') }}
                          </span>
                          <hr>
                          <v-data-table
                            :headers="hRelay"
                            :items="getInternalRelays(props.item.relays)"
                            :no-data-text="`${ Maglink.NoDataMessage(false) }`"
                            :no-results-text="`${ Maglink.NoDataMessage(true) }`"
                            hide-actions>
                            <template
                              slot="headerCell"
                              slot-scope="{ header }">
                              <span
                                class="dover-light-blue-color"
                                v-text="header.text" />
                            </template>
                            <template
                              slot="items"
                              slot-scope="{ item }"
                              class="dover-light-blue-color">
                              <td class="text-xs-center"> {{ item.relayNumber }}</td>
                              <td> {{ unpackLldTriggers(item.triggerStatus) }}</td>
                            </template>
                          </v-data-table>
                        </v-flex>
                        <v-flex
                          xs6
                          md4
                          lg4>
                          <span
                            class="dover-light-blue-color">
                            {{ $t('External relays') }}
                          </span>
                          <hr>
                          <v-data-table
                            :headers="hRelay"
                            :items="getExternalRelays(props.item.relays)"
                            :no-data-text="`${ Maglink.NoDataMessage(false) }`"
                            :no-results-text="`${ Maglink.NoDataMessage(true) }`"
                            hide-actions>
                            <template
                              slot="headerCell"
                              slot-scope="{ header }">
                              <span
                                class="dover-light-blue-color"
                                v-text="header.text" />
                            </template>
                            <template
                              slot="items"
                              slot-scope="{ item }"
                              class="dover-light-blue-color">
                              <td class="text-xs-center"> {{ item.relayNumber }}</td>
                              <td> {{ unpackLldTriggers(item.triggerStatus) }}</td>
                            </template>
                          </v-data-table>
                        </v-flex>
                        <v-flex
                          xs6
                          md4
                          lg4>
                          <span
                            class="dover-light-blue-color">
                            {{ $t('OM4 relays') }}
                          </span>
                          <hr>
                          <v-data-table
                            :headers="hRelay"
                            :items="getExternalOM4Relays(props.item.relays)"
                            :no-data-text="`${ Maglink.NoDataMessage(false) }`"
                            :no-results-text="`${ Maglink.NoDataMessage(true) }`"
                            hide-actions>
                            <template
                              slot="headerCell"
                              slot-scope="{ header }">
                              <span
                                class="dover-light-blue-color"
                                v-text="header.text" />
                            </template>
                            <template
                              slot="items"
                              slot-scope="{ item }"
                              class="dover-light-blue-color">
                              <td class="text-xs-center"> {{ item.relayNumber }}</td>
                              <td> {{ unpackLldTriggers(item.triggerStatus) }}</td>
                            </template>
                          </v-data-table>
                        </v-flex>
                      </v-layout>
                    </template>
                  </v-data-iterator>
                </v-flex>
              </v-layout>
            </v-form>
          </v-flex>
        </v-container>
      </v-card>
    </v-form>
  </material-card>
</template>

<script>

import Vue from 'vue'
import { i18n } from '@/i18n'
import print from 'print-js'

export default {
  props: {
    options: {
      type: Object,
      required: true,
      default: () => { }
    },
    sensors: {
      type: Array,
      required: true,
      default: () => { }
    },
    siteInfo: {
      type: Object,
      required: true,
      default: () => { }
    },
    systemSettings: {
      type: Object,
      required: true,
      default: () => { }
    },
    tankHeaders: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  data: () => ({
    baudRateList: [],
    buzzerLabel: i18n.t('Mute'),
    dataBitList: [],
    dipswitches: [],
    fairbanks: {},
    featureSettings: { serialNumber: '----' },
    hDipSwitch: [
      { sortable: false, text: i18n.t('Position'), align: 'center', width: '20%' },
      { sortable: false, text: i18n.t('Status'), align: 'center', width: '20%' },
      { sortable: false, text: i18n.t('Name'), align: 'left', width: '30%' },
      { sortable: false, text: i18n.t('Description'), align: 'left', width: '30%' }
    ],
    hLld: [
      { sortable: false, text: i18n.t('Tank'), align: 'center', width: '20%' },
      { sortable: false, text: 'I/O ' + i18n.t('Address'), align: 'center', width: '15%' },
      { sortable: false, text: 'I/O ' + i18n.t('Position'), align: 'center', width: '20%' },
      { sortable: false, text: i18n.t('Sensor Span (psi)'), align: 'right', width: '15%' },
      { sortable: false, text: 'LIM ' + i18n.t('Device'), align: 'center', width: '15%' },
      { sortable: false, text: 'LIM ' + i18n.t('Channel'), align: 'center', width: '15%' }
    ],
    hPipeline: [
      { sortable: false, text: i18n.t('Beta'), align: 'right', width: '20%' },
      { sortable: false, text: i18n.t('Calibrated Beta'), align: 'right', width: '20%' },
      { sortable: false, text: i18n.t('Line Length'), align: 'right', width: '10%' },
      { sortable: false, text: i18n.t('Pipeline (gal/ft)'), align: 'right', width: '10%' },
      { sortable: false, text: i18n.t('Minimum Test Pressure (psi)'), align: 'right', width: '20%' },
      { sortable: false, text: i18n.t('Minimum Dispensing Pressure (psi)'), align: 'right', width: '20%' }
    ],
    hProtocol: [
      { sortable: false, text: i18n.t('Pos'), align: 'center', width: '10%' },
      { sortable: false, text: i18n.t('Connection'), align: 'center', width: '10%' },
      { sortable: false, text: i18n.t('Sales'), align: 'center', width: '10%' },
      { sortable: false, text: i18n.t('Protocol'), align: 'left', width: '20%' },
      { sortable: false, text: i18n.t('Port'), align: 'center', width: '10%' },
      { sortable: false, text: i18n.t('Baud rate'), align: 'center', width: '10%' },
      { sortable: false, text: i18n.t('Parity'), align: 'center', width: '10%' },
      { sortable: false, text: i18n.t('Data bit'), align: 'center', width: '10%' },
      { sortable: false, text: i18n.t('Stop bit'), align: 'center', width: '10%' }
    ],
    hRelay: [
      { sortable: false, text: i18n.t('Relay'), align: 'center', width: '20%' },
      { sortable: false, text: i18n.t('Alarm'), align: 'left', width: '80%' }
    ],
    hSensor: [
      { sortable: false, text: i18n.t('Serial Number'), align: 'center', width: '25%' },
      { sortable: false, text: i18n.t('Sensor type'), align: 'left', width: '35%' },
      { sortable: false, text: i18n.t('Compliance'), align: 'center', width: '20%' },
      { sortable: false, text: i18n.t('Location'), align: 'left', width: '20%' }
    ],
    hTank: [
      { sortable: false, text: i18n.t('Serial Number'), align: 'center', width: '20%' },
      { sortable: false, text: i18n.t('Probe type'), align: 'left', width: '20%' },
      { sortable: false, text: i18n.t('Product family'), align: 'left', width: '20%' },
      { sortable: false, text: i18n.t('Tank group'), align: 'center', width: '10%' },
      { sortable: false, text: i18n.t('Height'), align: 'right', width: '10%' },
      { sortable: false, text: i18n.t('Max volume'), align: 'right', width: '10%' },
      { sortable: false, text: i18n.t('Offset product'), align: 'right', width: '10%' },
      { sortable: false, text: i18n.t('Offset water'), align: 'right', width: '10%' },
      { sortable: false, text: i18n.t('Water min float level'), align: 'right', width: '10%' }
    ],
    hThreshold: [
      { sortable: false, text: i18n.t('Safe working capacity'), align: 'center', width: '10%' },
      { sortable: false, text: i18n.t('High') + ' ' + i18n.t('High'), align: 'right', width: '8%' },
      { sortable: false, text: i18n.t('High'), align: 'right', width: '8%' },
      { sortable: false, text: i18n.t('Low'), align: 'right', width: '8%' },
      { sortable: false, text: i18n.t('Low') + ' ' + i18n.t('Low'), align: 'right', width: '8%' },
      { sortable: false, text: i18n.t('Water'), align: 'right', width: '8%' },
      { sortable: false, text: 'AEF T1', align: 'right', width: '8%' },
      { sortable: false, text: 'AEF t1', align: 'right', width: '8%' },
      { sortable: false, text: 'AEF t2', align: 'right', width: '8%' },
      { sortable: false, text: 'AEF T2', align: 'right', width: '8%' },
      { sortable: false, text: i18n.t('Sudden loss'), align: 'right', width: '10%' },
      { sortable: false, text: i18n.t('Leak'), align: 'right', width: '8%' }
    ],
    isValidationOk: false,
    language: '',
    lldEvents: [],
    llds: [],
    mainSettings: {
      comm1: 0,
      comm2: 0,
      tcpIpPort: 0,
      printer: 0,
      defaultLeakThreshold: 1,
      gilbarcoInvalidDataFill: 0,
      enableGilbarcoSetCommands: false,
      posProtocols: []
    },
    network: {},
    parityList: [],
    relayTank: false,
    relaySensor: false,
    relayLld: false,
    sensorEvents: [],
    sensorTypes: [],
    stopBitList: [],
    tankEvents: [],
    tanks: []
  }),
  watch: {
    options: {
      handler: function (newOptions, oldOptions) {
        if (newOptions !== undefined) {
          if (this.lldEvents.length === 0) {
            newOptions.lldEvents.slice(1).forEach(d => { this.lldEvents.push({ code: d.code, desc: this.$t(d.desc) }) })
          }
          if (this.sensorEvents.length === 0) {
            newOptions.sensorEvents.slice(1).forEach(d => { this.sensorEvents.push({ code: d.code, desc: this.$t(d.desc) }) })
          }
          if (this.tankEvents.length === 0) {
            newOptions.tankEvents.slice(1).forEach(d => { this.tankEvents.push({ code: d.code, desc: this.$t(d.desc) }) })
          }
        }
      },
      immediate: true
    },
    systemSettings: {
      handler: function (newSystemSettings, oldSystemSettings) {
        this.language = 'Undefined'
        this.Maglink.GetLanguages()
          .then(resp => {
            resp.data.forEach(item => {
              if (item.id === newSystemSettings.language) {
                this.language = this.$t(item.language)
                this.buzzerLabel = this.systemSettings.alarmDuration < 1 ? i18n.t('Mute') : this.systemSettings.alarmDuration < 60 ? i18n.t('Short') : this.systemSettings.alarmDuration < 250 ? i18n.t('Long') : i18n.t('Continuous')
              }
            })
          })
          .catch(error => (this.snack('error', error.message)))
      },
      immediate: true
    }
  },
  mounted () {
    this.Maglink.GetSettings('Dipswitches')
      .then(
        response => {
          this.dipswitches = response.data
          this.dipswitches[7].name = this.$t('W&M')
        }).catch(error => (this.snack('error', error.message)))

    this.sensorTypes = this.Maglink.SensorTypesBasic()
    if (Vue.prototype.Maglink.isPlus) {
      this.sensorTypes = this.sensorTypes.concat(this.Maglink.SensorTypesPlus())
    }

    this.Maglink.GetSettings('SystemProtocols')
      .then(response => {
        this.mainSettings = { ...this.mainSettings, ...response.data }
      }).catch(error => (this.snack('error', error.message)))

    this.baudRateList.push({ code: 9600, desc: '9600' })
    this.baudRateList.push({ code: 4800, desc: '4800' })
    this.baudRateList.push({ code: 2400, desc: '2400' })
    this.baudRateList.push({ code: 1200, desc: '1200' })
    this.parityList.push({ code: 'N', desc: this.$t('None') })
    this.parityList.push({ code: 'E', desc: this.$t('Even') })
    this.parityList.push({ code: 'O', desc: this.$t('Odd') })
    this.dataBitList.push({ code: 8, desc: '8' })
    this.dataBitList.push({ code: 7, desc: '7' })
    this.stopBitList.push({ code: 1, desc: '1' })
    this.stopBitList.push({ code: 2, desc: '2' })

    this.Maglink.GetSettings('Fairbanks')
      .then(response => {
        this.fairbanks = { ...this.fairbanks, ...response.data }
      }).catch(error => (this.snack('error', error.message)))

    this.Maglink.GetTanks()
      .then(response => {
        this.tanks = response.data

        for (var i = 0; i < this.tanks.length; i++) {
          this.tanks[i] = this.Maglink.ToDisplay(this.tanks[i], this.systemSettings.levelUnit, this.systemSettings.volumeUnit)
        }
      }).catch(error => (this.snack('error', error.message)))

    this.Maglink.GetNetwork()
      .then(response => {
        this.network = response.data

        if (typeof this.Maglink.RulesIP(this.network.gateway) === 'string') {
          this.network.dhcp = true
        } else {
          this.network.dhcp = false
        }
      })
      .catch(error => (this.snack('error', error.message)))

    this.Maglink.GetLlds()
      .then(response => {
        this.llds = response.data
      })
      .catch(error => (this.snack('error', error.message)))

    this.Maglink.GetSettings('Features')
      .then(response => {
        this.featureSettings.serialNumber = response.data.serialNumber
      })
      .catch(() => {
        this.snack('error', 'Session timeout')
      })
  },
  methods: {
    getAEFLevel (type, value) {
      if (type) {
        return value
      } else {
        return '---'
      }
    },
    getBaudRate (protocol) {
      if (protocol.type !== 0) {
        return '---'
      } else {
        let rate = this.baudRateList.find((item) => item.code === protocol.baudRate)
        if (rate !== undefined) {
          return rate.desc
        } else {
          return '---'
        }
      }
    },
    getBoolean (value) {
      if (value === true) {
        return this.$t('Enabled')
      } else {
        return this.$t('Off')
      }
    },
    getDataBit (protocol) {
      if (protocol.type !== 0) {
        return '---'
      } else {
        let rate = this.dataBitList.find((item) => item.code === protocol.dataBit)
        if (rate !== undefined) {
          return rate.desc
        } else {
          return '---'
        }
      }
    },
    getDescription (index) {
      if (index === 0) return this.$t('OFF: Normal; OK: Inverted')
      if (index === 1) return this.$t('OFF: Disabled; OK: Enabled')
      if (index === 7) return this.$t('OFF: Inactive; OK: W&M approved')
    },
    getDispensingPressure (value) {
      if (value > 16.00) {
        return this.Maglink.RoundFormat(value, 2)
      } else {
        return '16.00'
      }
    },
    getExternalRelays (list) {
      var relays = []

      if (this.siteInfo.externalRelays > 0) {
        for (var i = 0; i < list.length; i++) {
          if (!list[i].internal && !list[i].externalOM4) {
            relays.push(list[i])
          }
        }
        relays = relays.sort((a, b) => (b.relayNumber < a.relayNumber) ? 1 : -1)
        relays.length = this.siteInfo.externalRelays
      }
      return relays
    },
    getExternalOM4Relays (list) {
      var relays = []

      if (this.siteInfo.externalOM4Relays > 0) {
        for (var i = 0; i < list.length; i++) {
          if (list[i].externalOM4) {
            relays.push(list[i])
          }
        }
        relays = relays.sort((a, b) => (b.relayNumber < a.relayNumber) ? 1 : -1)
        relays.length = this.siteInfo.externalOM4Relays
      }
      return relays
    },
    getGilbarcoInvalidField (field) {
      if (field !== '0'.charCodeAt(0)) {
        return '?'
      } else {
        return '0'
      }
    },
    getInternalRelays (list) {
      var relays = []
      var max = this.Maglink.isPlus ? 2 : 4
      for (var i = 0; i < list.length; i++) {
        if (list[i].internal) {
          relays.push(list[i])
        }
      }
      relays = relays.sort((a, b) => (b.relayNumber < a.relayNumber) ? 1 : -1)
      relays.length = max
      return relays
    },
    getItemAsList (item) {
      var list = []
      list.push(item)
      return list
    },
    getLeakValue (value, probeType) {
      if (!(probeType > 5 && probeType !== 14)) {
        return this.Maglink.LeakageToDisplay(value, this.systemSettings.volumeUnit || 0)
      } else {
        return '---'
      }
    },
    getLength (value) {
      return this.Maglink.LevelToDisplay(value, this.systemSettings.levelUnit)
    },
    getLink (mode) {
      switch (mode) {
        case 0:
          return this.$t('Serial')
        case 1:
          return this.$t('Tcp-Ip').toUpperCase()
        case 2:
          return this.$t('None')
        default:
          return '---'
      }
    },
    getLldInfo (value) {
      if (value === 0) {
        return this.$t('OFF')
      } else {
        return value
      }
    },
    getNetworkMode (mode) {
      if (mode === true) {
        return this.$t('DHCP')
      } else {
        return this.$t('Static IP')
      }
    },
    getParity (protocol) {
      if (protocol.type !== 0) {
        return '---'
      } else {
        let rate = this.parityList.find((item) => item.code === protocol.parity)
        if (rate !== undefined) {
          return rate.desc
        } else {
          return '---'
        }
      }
    },
    getPrinter (printer) {
      switch (printer) {
        case 0:
          return this.$t('USB')
        case 1:
        case 2:
          return this.$t('Comm {0}', [ printer ])
        case 9:
          return this.$t('None')
        default:
          return '---'
      }
    },
    getProbeType (typeCode) {
      let probe = this.options.probeTypes.find((item) => item.code === typeCode)
      if (probe !== undefined) {
        return probe.desc
      } else {
        return '---'
      }
    },
    getProductName (tank) {
      let header = this.tankHeaders.find((item) => item.tankNumber === tank)
      if (header !== undefined) {
        return header.productFamilyName
      } else {
        return 'Undefined'
      }
    },
    getProtocol (mode) {
      let protocol = this.options.protocols.find((item) => item.code === mode)
      if (protocol !== undefined) {
        return protocol.desc
      } else {
        return '---'
      }
    },
    getSensorLocation (sensor) {
      switch (sensor.associationType) {
        case 0: // tank
          return this.$t('Tank') + ' ' + sensor.associationAddress
        case 2: // sump
          return this.$t('Sump') + ' ' + sensor.associationAddress
        case 3:
          return this.$t('Site/well')
        default:
          return 'Undefined ' + sensor.associationType
      }
    },
    getSensorType (typeCode) {
      let sensorType = this.sensorTypes.find((item) => item.code === typeCode)
      if (sensorType !== undefined) {
        return sensorType.desc
      } else {
        return '---'
      }
    },
    getSftpStatus (status) {
      if (status === 1) {
        return this.$t('Enabled')
      } else {
        return this.$t('Disabled')
      }
    },
    getStopBit (protocol) {
      if (protocol.type !== 0) {
        return '---'
      } else {
        let rate = this.stopBitList.find((item) => item.code === protocol.stopBit)
        if (rate !== undefined) {
          return rate.desc
        } else {
          return '---'
        }
      }
    },
    getSwitchStatus (status) {
      return status === false ? this.$t('Off').toUpperCase() : this.$t('On').toUpperCase()
    },
    getTankGroupName (tank) {
      let header = this.tankHeaders.find((item) => item.tankNumber === tank)
      if (header !== undefined) {
        return header.groupName
      } else {
        return 'Undefined'
      }
    },
    getTestPressure (value) {
      if (value > 20.00) {
        return this.Maglink.RoundFormat(value, 2)
      } else {
        return '20.00'
      }
    },
    getTransferMode (modeCode) {
      let mode = this.options.transferModes.find((item) => item.code === modeCode)
      if (mode !== undefined) {
        return mode.desc
      } else {
        return 'Undefined'
      }
    },
    getVolumeinGallons (value) {
      return this.Maglink.RoundFormat(value / (3.78541 / 304.8), 5)
    },
    getWaterLevel (floats, value) {
      if (floats > 0) {
        return value
      } else {
        return '---'
      }
    },
    onPrintForm () {
      this.snack('warning', this.$t('Check print settings'))

      // Get all stylesheets HTML
      let stylesHtml = ''
      for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
        stylesHtml += node.outerHTML
      }

      print({
        printable: 'print-layout',
        type: 'html',
        scanStyles: false,
        css: stylesHtml
      })
    },
    unpackLldTriggers (eventMask) {
      let triggers = ''
      let mask = 1
      for (let i = 0; i < 32; i++) {
        if ((eventMask & mask) === mask) {
          let status = this.lldEvents.find(e => e.code === mask)
          triggers = triggers + '; ' + (status !== undefined ? status.desc : mask)
        }
        mask = mask * 2
      }

      if (triggers.length > 2) {
        return triggers.substring(2)
      } else {
        return '---'
      }
    },
    unpackSensorTriggers (eventMask) {
      let triggers = ''
      let mask = 1
      for (let i = 0; i < 32; i++) {
        if ((eventMask & mask) === mask) {
          let status = this.sensorEvents.find(e => e.code === mask)
          triggers = triggers + '; ' + (status !== undefined ? status.desc : mask)
        }
        mask = mask * 2
      }

      if (triggers.length > 2) {
        return triggers.substring(2)
      } else {
        return '---'
      }
    },
    unpackTankTriggers (eventMask) {
      let triggers = ''
      let mask = 1
      for (let i = 0; i < 32; i++) {
        if ((eventMask & mask) === mask) {
          let status = this.tankEvents.find(e => e.code === mask)
          triggers = triggers + '; ' + (status !== undefined ? status.desc : mask)
        }
        mask = mask * 2
      }

      if (triggers.length > 2) {
        return triggers.substring(2)
      } else {
        return '---'
      }
    },
    snack (color, message) {
      this.$store.dispatch('showSnackbar', { color, message, show: true })
    }
  }
}

</script>
